
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
<inscripcion />
 <v-row  justify="center">
   <v-col  cols="12" lg="12" md="12" sm="12">
   <v-card color="#393E46">
     <v-card-title><v-btn icon :top="top" :right="right" @click="$router.go(-1)">
       <v-icon>far fa-times-circle</v-icon>
     </v-btn></v-card-title>
     <v-card-text>
       <v-row justify="center" align="top">
         <v-divider inset></v-divider>
          <v-col cols="12" md="12" lg="12" sm="12">
            <h1 class="text-center"> {{acto.nombre}}</h1>
          </v-col>
       <v-divider inset></v-divider>
       </v-row> <v-row justify="center" align="top">
       <v-col cols="6" sm="6" lg="6" md="6">
         <h2 class="text-center"> Fecha Evento : {{formatDatee(acto.fechaInicio)}} Desde {{acto.horaInicio}}</h2>
       </v-col>
       <v-col cols="6" sm="6" lg="6" md="6">
         <h2 class="text-center"> {{acto.ubicacion}}</h2>
       </v-col>
       </v-row>
         <v-row  align="top">
           <v-col  cols="12" lg="8" sm="12" md="8">
             <v-card color="#6D9886">
               <v-card-title>Entradas</v-card-title>
               <v-card-text>
                   <v-data-table
                       :headers="headers"
                       :items="entradas"
                       class="elevation-1"
                       hide-default-footer
                       no-data-text="No hay entradas disponibles para mostrar."
                       no-results-text="No hay resultados para la búsqueda."
                       loading-text="Cargando... Por favor espere."
                       style="background-color: #393E46;"
                   >
                     <template v-slot:[`item.action`]="{ item }">
                       <div  v-if="item.tiene">
                         Adquirida
                       </div>
                       <div v-else>
                         <div v-if="compareDates(item)">
                           <v-row justify="center" align="center">
                             <v-col cols="3">
                               <v-select :items="cantentrad" style="width:20px;"></v-select>
                             </v-col>
                             <v-col cols="9">
                               <v-btn   v-if="item.eventoentrada.tipoEntrada.pago"  color="primary" @click="comprar(item)"><v-icon >fas fa-cart-plus</v-icon> Adquirir</v-btn>
                               <v-btn v-else color="green" @click="inscribirse(item)"><v-icon >fas fa-gift</v-icon>  Inscribirse</v-btn>

                             </v-col>
                           </v-row>
                          </div>
                         <div v-else>
                          Entrada Vencida
                         </div>
                            </div>
                     </template>
                     <template v-slot:[`item.price`]="{ item }">
                       {{item.eventoentrada.moneda.shortmoneda}} {{item.eventoentrada.precio}}
                     </template>
                   </v-data-table>

               </v-card-text>
             </v-card>

           </v-col>
     <v-col cols="12" lg="4" sm="12" md="4">
       <v-row>
         <v-col cols="12" >

           <h2>Descripción de Evento</h2>

         </v-col>
         <v-col cols="12" >

         </v-col>
         <v-col cols="12">
           <v-img v-if="foto===''" max-height="300" contain  src="@/assets/no-image.jpeg"
           ></v-img>
           <v-img v-else max-height="300" contain :src="foto"></v-img>
         </v-col>
         <v-col cols="12">
           <v-row>
             <v-col cols="12" sm="12" lg="12" md="12">
               <gmaps-map @mounted="ready" :options="options"
                          style='width:100%;  height: 400px;'>
                 <gmaps-marker :position="options.position" :options="optionsMarker"  />
               </gmaps-map>

             </v-col>
           </v-row>
         </v-col>
       </v-row>


     </v-col>


     </v-row>

   </v-card-text>
   </v-card></v-col>
 </v-row>





  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import store from "@/store";
import Cabecerabaja from "@/components/general/cabecerabaja";
import Inscripcion from "@/components/modals/inscripcion";
import { gmaps, gmapsMap, gmapsMarker } from 'x5-gmaps';

  export default {
    name: 'acto',
    components: {
      Inscripcion,
      Cabecerabaja,
    cabecera,
    piepagina,
      gmapsMap,
      gmapsMarker
  },
    data () {
      return {
        clientesimg: [],
        tag: '',
        acto:{
          nombre:'',
        ventaapp:false,
        freapp:false,
        fechaInicio: new Date(),
        fechaFin: new Date(),
        horaInicio:'00:00:00'} ,
        titulonegocio:'',
        top:true,
        entradas:[],
        entradaseve:[],
        entradaevento:{},
        right:true,
        cantentrad:[1,2,3,4],
        direction:'top',
        center: { lat: 45.508, lng: -73.587 },
        foto:'',
        options:{
          position:{ lat: -12.0792903, lng: -77.004896 },
          center:{ lat: -12.0792903, lng: -77.004896 },
          zoom: 18
        },
        optionsMarker:{
          draggable:false
        },
        tipocompra:'',
        organizador:'',
        horaInicio:'',
        horaFinal:'',
        conectado:false,
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          ,
          headers: [
        { text: '', value: 'action', sortable: false },
        { text: 'Entrada', align: 'left',  value: 'eventoentrada.eventoEntrada'},
        { text: 'Precio', value: 'price' }
      ]
          }
    },
    mounted(){
      this.tag =  this.$route.params.tag
      this.traeActo()
      if(this.usuario.id>0){
        this.conectado = true

      }else{
        this.conectado = false
      }
    },
    metaInfo() {
      return {
        title: this.titulonegocio,
        meta: [
          {property: "og:image", content: this.logoimg},
          {property: "og:image:width", content: "699"},
          {property: "og:image:height", content: "366"},
          {
            property: "og:description",
            content: this.titulonegocio
          }
        ]
      }
    },
    watch:{
      '$store.state.usuario': function (){
        this.conectado = true
        this.dameEntradas()
      },
      '$store.state.showInscribete': function (){
        this.dameEntradas()
      }
    },
    methods: {
      formatDatee(value) {
        return moment(value).locale('es-pe').format("DD MMMM YYYY")
      },
      ready(map) {
        this.map = map
        gmaps().then((maps) => {
          this.places = new maps.places.PlacesService(map)
          this.autocomplete = new maps.places.Autocomplete(this.$refs.autocomplete)
          this.autocomplete.addListener('place_changed', this.update)
        })
      },
      update() {
        const place = this.autocomplete.getPlace()
        if (place.geometry) {
          this.map.panTo(place.geometry.location)
          this.markerPos = place.geometry.location
          this.options.position = place.geometry.location
          this.options.center = place.geometry.location
          this.editedItem.latitud = place.geometry.viewport.eb.hi
          this.editedItem.longitud = place.geometry.viewport.Ha.hi
          //  let disct = place.address_components.find(x=>x.types[0]==="locality")

        }
      },
      inscribirse(item){
        store.dispatch("showInscripcion")
        this.entradaevento =  item.eventoentrada
      },
      comprar(item){
        console.log(item)
      },
      traeActo(){
        this.overlay = true
        axios.get("actos/"+this.tag, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
            .then((response)  => {
              this.acto = response.data;
              this.titulonegocio = this.acto.nombre
              store.dispatch("fetchEvento", response.data);
              this.overlay = false

              this.dameEntradas()

              if(this.acto.foto === '' || this.acto.foto === null){

              if (this.acto.negocio === null ){
                if(this.acto.cliente === null){
                  this.foto='sinimagen'
                }else{
                  this.foto = this.acto.cliente.logo
                }
              }else{
                this.foto = this.acto.negocio.logo
              }}else{
                this.foto = this.acto.foto
              }
              if (this.acto.negocio == null ){
                if(this.acto.cliente == null){
                  this.organizador=''
                }else{
                  this.organizador=this.acto.cliente.cliente
                }
                this.options.center = {
                  lat: parseFloat(this.acto.lat),
                  lng: parseFloat(this.acto.lng)
                }
                this.options.position = {
                  lat: parseFloat(this.acto.lat),
                  lng: parseFloat(this.acto.lng)
                }
                this.horaInicio = this.acto.horaInicio
                this.horaFinal = this.acto.horaFinal
              }else{
                this.organizador = this.acto.negocio.negocioNombre
                this.horaInicio = this.acto.negocio.horaApertura
                this.horaFinal = this.acto.negocio.horaCierre

                this.options.center  = {
                  lat: parseFloat(this.acto.negocio.latitud),
                  lng: parseFloat(this.acto.negocio.longitud)
                }
                this.options.position  = {
                  lat: parseFloat(this.acto.negocio.latitud),
                  lng: parseFloat(this.acto.negocio.longitud)
                }
              }


            })
            .catch((error)  => {
              console.log(error);
            });
      },

      dameEntradas(){
        this.overlay = true
        var bodyFormData = new FormData();

        if(this.conectado){
          bodyFormData.append("personaId",this.usuario.id)
          bodyFormData.append("eventoId",this.acto.id)
          axios
              .post('tickets/entrada',bodyFormData)
              .then(response => {
                this.entradas = response.data
                this.overlay = false

              })
              .catch(error => {
                console.error(error);
              });
        }else{
          axios
              .get('eventoentradas/evento/'+this.evento.id)
              .then(response => {
                this.entradaseve = response.data
                this.overlay = false
              })
              .catch(error => {
                console.error(error);
              });
        }
      },
      comparaFechas(item){
        let fecIni = new Date(item.eventoentrada.fechaInicio + " 00:00:00");
        let fecFin = new Date(item.eventoentrada.fechaFin + " 00:00:00");
        let datenow = new Date();
        if( datenow >= fecIni && datenow<= fecFin){
          return true
        }else{
          return false
        }
      }

    },
computed: {
  // map `this.user` to `this.$store.getters.user`
...mapGetters({
    usuario: "usuario",
    evento: "evento"
  }),
      compareDates: function() {
    return (item) => this.comparaFechas(item);
  }
}
  }
</script>
